export enum SocialMediaEnum {
  Facebook = "Facebook",
  Instagram = "Instagram",
  Linkedin = "Linkedin",
  TikTok = "TikTok",
  YouTube = "YouTube",
}
